import { render, staticRenderFns } from "./CategoriasJuegos.vue?vue&type=template&id=24065c62&scoped=true"
import script from "./CategoriasJuegos.vue?vue&type=script&lang=js"
export * from "./CategoriasJuegos.vue?vue&type=script&lang=js"
import style0 from "./CategoriasJuegos.vue?vue&type=style&index=0&id=24065c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24065c62",
  null
  
)

export default component.exports